<div class="sync-results-modal">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 mat-dialog-title class="modal-title">
      <mat-icon class="title-icon" svgIcon="sync"></mat-icon>
      {{ 'integration.sync_results' | transloco }}
    </h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onClose()"
      [attr.aria-label]="'Close dialog'"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div mat-dialog-content class="modal-content">
    <!-- Success Results -->
    <div *ngIf="isSuccessful()" class="success-results">
      <!-- Success Alert -->
      <div class="alert alert-success">
        <mat-icon class="alert-icon" svgIcon="check_circle"></mat-icon>
        <div class="alert-content">
          <h4>{{ 'integration.sync_successful' | transloco }}</h4>
          <p>{{ 'integration.sync_completed_successfully' | transloco }}</p>
        </div>
      </div>

      <!-- Statistics Grid -->
      <div class="stats-grid">
        <div class="stat-card created">
          <div class="stat-number">{{ syncResult.projects_created || 0 }}</div>
          <div class="stat-label">{{ 'integration.projects_created' | transloco }}</div>
        </div>
        <div class="stat-card updated">
          <div class="stat-number">{{ syncResult.projects_updated || 0 }}</div>
          <div class="stat-label">{{ 'integration.projects_updated' | transloco }}</div>
        </div>
        <div class="stat-card matched">
          <div class="stat-number">{{ syncResult.projects_matched || 0 }}</div>
          <div class="stat-label">{{ 'integration.projects_matched' | transloco }}</div>
        </div>
        <div class="stat-card failed">
          <div class="stat-number">{{ syncResult.projects_failed || 0 }}</div>
          <div class="stat-label">{{ 'integration.projects_failed' | transloco }}</div>
        </div>
      </div>

      <!-- Success Rate -->
      <div class="success-rate">
        <mat-progress-bar
          mode="determinate"
          [value]="getSuccessRate()"
          color="primary"
        ></mat-progress-bar>
        <span class="rate-text"
          >{{ getSuccessRate() }}% {{ 'integration.success_rate' | transloco }}</span
        >
      </div>

      <!-- Project IDs Section -->
      <div *ngIf="hasProjectIds()" class="project-ids-section">
        <h5 class="project-ids-title">
          <mat-icon class="info-icon" svgIcon="info"></mat-icon>
          {{ 'integration.project_ids' | transloco }}
        </h5>

        <div class="project-ids-grid">
          <!-- Created Projects -->
          <div *ngIf="getProjectIds('created').length > 0" class="project-ids-card created">
            <div class="card-header">
              <mat-icon class="card-icon" svgIcon="add_circle"></mat-icon>
              <span class="card-title">{{ 'integration.projects_created' | transloco }}</span>
              <span class="card-count">({{ getProjectIds('created').length }})</span>
            </div>
            <div class="project-ids-list">
              <div *ngFor="let project of getProjectIds('created')" class="project-id-item">
                <code class="project-id"
                  ><a [href]="'/project-d/' + project.id + '/info'" target="_blank"
                    >{{ project.project_number }} - {{ project.project_name }}</a
                  ></code
                >
              </div>
            </div>
          </div>

          <!-- Updated Projects -->
          <div *ngIf="getProjectIds('updated').length > 0" class="project-ids-card updated">
            <div class="card-header">
              <mat-icon class="card-icon" svgIcon="update"></mat-icon>
              <span class="card-title">{{ 'integration.projects_updated' | transloco }}</span>
              <span class="card-count">({{ getProjectIds('updated').length }})</span>
            </div>
            <div class="project-ids-list">
              <div *ngFor="let project of getProjectIds('updated')" class="project-id-item">
                <code class="project-id"
                  ><a [href]="'/project-d/' + project.id + '/info'" target="_blank"
                    >{{ project.project_number }} - {{ project.project_name }}</a
                  ></code
                >
              </div>
            </div>
          </div>

          <!-- Matched Projects -->
          <div *ngIf="getProjectIds('matched').length > 0" class="project-ids-card matched">
            <div class="card-header">
              <mat-icon class="card-icon" svgIcon="find_in_page"></mat-icon>
              <span class="card-title">{{ 'integration.projects_matched' | transloco }}</span>
              <span class="card-count">({{ getProjectIds('matched').length }})</span>
            </div>
            <div class="project-ids-list">
              <div *ngFor="let project of getProjectIds('matched')" class="project-id-item">
                <code class="project-id"
                  ><a [href]="'/project-d/' + project.id + '/info'" target="_blank"
                    >{{ project.project_number }} - {{ project.project_name }}</a
                  ></code
                >
              </div>
            </div>
          </div>

          <!-- Failed Projects -->
          <div *ngIf="getProjectIds('failed').length > 0" class="project-ids-card failed">
            <div class="card-header">
              <mat-icon class="card-icon" svgIcon="error"></mat-icon>
              <span class="card-title">{{ 'integration.projects_failed' | transloco }}</span>
              <span class="card-count">({{ getProjectIds('failed').length }})</span>
            </div>
            <div class="project-ids-list">
              <div *ngFor="let project of getProjectIds('failed')" class="project-id-item failed">
                <code class="project-id"
                  >{{ project.project_number }} - {{ project.project_name }}</code
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Results -->
    <div *ngIf="!isSuccessful()" class="error-results">
      <div class="alert alert-error">
        <mat-icon class="alert-icon" svgIcon="error"></mat-icon>
        <div class="alert-content">
          <h4>{{ 'integration.sync_failed' | transloco }}</h4>
          <p>{{ syncResult.message || ('integration.sync_failed_message' | transloco) }}</p>
        </div>
      </div>

      <!-- Validation Errors -->
      <div *ngIf="syncResult.errors && syncResult.errors.length > 0" class="validation-errors">
        <h5>{{ 'integration.validation_errors' | transloco }}</h5>
        <ul class="error-list">
          <li *ngFor="let error of syncResult.errors" class="error-item">
            <strong>{{ error.field }}:</strong> {{ error.message }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Failures Section -->
    <div *ngIf="hasFailures()" class="failures-section">
      <h5 class="failures-title">
        <mat-icon class="warning-icon" svgIcon="warning"></mat-icon>
        {{ 'integration.sync_failures' | transloco }}
      </h5>

      <div class="failures-list">
        <div *ngFor="let failure of syncResult.failures" class="failure-item">
          <div class="failure-header">
            <strong>{{ failure.project_number }}</strong>
            <span class="project-name">{{ failure.project_name }}</span>
          </div>
          <div class="failure-reason">{{ failure.reason }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Actions -->
  <div mat-dialog-actions class="modal-actions">
    <button mat-button class="cancel-button" (click)="onClose()">
      {{ 'common.close' | transloco }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="refresh-button"
      *ngIf="isSuccessful()"
      (click)="onRefreshProjects()"
    >
      <mat-icon svgIcon="refresh"></mat-icon>
      {{ 'integration.refresh_projects' | transloco }}
    </button>
  </div>
</div>
